import React, { useEffect, useRef, useState } from "react";
import "./pagination.css"
import { current } from "@reduxjs/toolkit";

const Pagination = (props) => {
    const [page, setPage] = useState(1);

    var [active,setActive] = useState(props.pagination_data?.current_page || 1);
    // var active = props.pagination_data?.current_page || 1;

    var inputRef = useRef(null);

    const containRef = useRef(null);
    const totalPages = props.pagination_data?.total_pages;

    // alert(JSON.stringify(props.pagination_data))

    const num = 0;

    const handleType=(e)=>{
        const text = e.target.value;
        if(/^[1-9]\d*$/.test(text)){
          const num = parseInt(text || "0",10);
          if(num<=totalPages){
            e.target.value = text;
          }else{
            e.target.value = totalPages;
          }
        }else{
          e.target.value = "";
        }
    }

    const goToPage=()=>{
      const page = Number(inputRef.current.value);
      if(page!==0){
        setStart(page)
        setActive(page)
        // active=page;
        props.PaginationControl("page",page);
        inputRef.current.value="";
      }
    }

    var PAGE_SIZE = Math.min(5, totalPages || 0);

    // if(totalPages<5){
    //   PAGE_SIZE = totalPages;
    // }else{
    //   PAGE_SIZE = 5;
    // }

    const [start, setStart] = useState(1);

    const getItems = () => {
      // if we're close to the end, shift start left
      if (start + PAGE_SIZE - 1 > totalPages) {
        const newStart = Math.max(1, totalPages - PAGE_SIZE + 1);
        return Array.from({ length: PAGE_SIZE }, (_, i) => newStart + i);
      }

      return Array.from({ length: PAGE_SIZE }, (_, i) => start + i);
    };

    var items = getItems();

    const fun1 = (dir) => {
      if (dir === "left") {
        if (start > 1) {
          const newStart = Math.max(1, start - PAGE_SIZE);

          setStart(newStart);
          props.PaginationControl("page", newStart);
        }
      }

      if (dir === "right") {
        if (start + PAGE_SIZE <= totalPages) {
          const newStart = start + PAGE_SIZE;

          setStart(newStart);
          props.PaginationControl("page", newStart);
        }
      }
    };

    const next_prev_page=(dir)=>{
        if (dir === "previous" && active - 1 >= 1) {
        const nm = active -1;
        // alert("prev")
        props.PaginationControl("page",nm);
        setActive(nm)
        // active=nm;
        if (nm < start) {
          setStart(Math.max(1, start - PAGE_SIZE));
        }
      }
      
      if (dir === "next" && active + 1 <= totalPages) {
        const nm = active +1;
        // alert("next")
        props.PaginationControl("page",nm);
        setActive(nm)
        // active=nm;
        if (nm > start + PAGE_SIZE - 1) {
          setStart(start + PAGE_SIZE);
        }
      }
    }

    const handleActive=(e)=>{
      const val = parseInt(e.target.innerText);
      setActive(val);
      // active=val;
      props.PaginationControl("page",val);
    }

    const handleFirstLast=(text)=>{
      if(props.pagination_data){
        if(text=="first"){
          props.PaginationControl("page",1);
          setActive(1);
          // active=1;
          setStart(1)
        }else if(text=="last" && totalPages){
          props.PaginationControl("page",totalPages);
          setActive(totalPages);
          // active=totalPages;
          setStart(Math.max(1, totalPages - PAGE_SIZE + 1))
        }
      }
    }

    const [showOverlay, setShowOverlay] = useState(false);

    useEffect(()=>{
      if(props.pagination_data?.current_page){
        setActive(props.pagination_data.current_page)
      }
    },[props.pagination_data.current_page])

    useEffect(() => {
      if (!totalPages || PAGE_SIZE === 0) return;

      // active moved before window
      if (active < start) {
        setStart(Math.max(1, active - PAGE_SIZE + 1));
      }
      // active moved after window
      else if (active > start + PAGE_SIZE - 1) {
        setStart(active);
      }
    }, [active, totalPages, PAGE_SIZE]);


  return (
    <>
    {props.pagination_data?.current_page_count!==0 && (


    // <div className="flex items-center justify-center lg:px-0 sm:px-6 px-4">
    //   <div className=" w-full  flex items-center justify-between border-t border-gray-200 ">
    //     <div className="flex items-center pt-3 text-gray-600 dark:text-gray-200  hover:text-indigo-700 cursor-pointer">
    //       <svg
    //         width="14"
    //         height="8"
    //         viewBox="0 0 14 8"
    //         fill="none"
    //         xmlns="http://www.w3.org/2000/svg"
    //       >
    //         <path
    //           d="M1.1665 4H12.8332"
    //           stroke="currentColor"
    //           strokeWidth="1.25"
    //           strokeLinecap="round"
    //           strokeLinejoin="round"
    //         />
    //         <path
    //           d="M1.1665 4L4.49984 7.33333"
    //           stroke="currentColor"
    //           strokeWidth="1.25"
    //           strokeLinecap="round"
    //           strokeLinejoin="round"
    //         />
    //         <path
    //           d="M1.1665 4.00002L4.49984 0.666687"
    //           stroke="currentColor"
    //           strokeWidth="1.25"
    //           strokeLinecap="round"
    //           strokeLinejoin="round"
    //         />
    //       </svg>
    //       <p
    //         className="text-sm ml-3 font-medium leading-none"
    //         onClick={(e) => props.PaginationControl("first", "")}
    //       >
    //         First
    //       </p>
    //     </div>

    //     <div className="sm:flex hidden">
    //       {Array.from(
    //         { length: props?.pagination_data?.total_pages || 0 },
    //         (_, index) => (
    //           <p
    //             onClick={(e) => props.PaginationControl("page", index + 1)}
    //             className={`text-sm font-medium leading-none cursor-pointer ${
    //               props?.pagination_data?.current_page == index + 1
    //                 ? "text-indigo-700 dark:text-indigo-400 border-t border-indigo-400 pt-3 mr-4 px-2"
    //                 : " text-gray-600 dark:text-gray-200  hover:text-indigo-700 dark:hover:text-indigo-400 border-t border-transparent hover:border-indigo-400 pt-3 mr-4 px-2"
    //             }`}
    //           >
    //             {index + 1}
    //           </p>
    //         )
    //       )}
    //     </div>

    //     <div className="flex items-center pt-3 text-gray-600 dark:text-gray-200  hover:text-indigo-700 cursor-pointer">
    //       <p
    //         className="text-sm font-medium leading-none mr-3"
    //         onClick={(e) => props.PaginationControl("last", "")}
    //       >
    //         Last
    //       </p>
    //       <svg
    //         width="14"
    //         height="8"
    //         viewBox="0 0 14 8"
    //         fill="none"
    //         xmlns="http://www.w3.org/2000/svg"
    //       >
    //         <path
    //           d="M1.1665 4H12.8332"
    //           stroke="currentColor"
    //           strokeWidth="1.25"
    //           strokeLinecap="round"
    //           strokeLinejoin="round"
    //         />
    //         <path
    //           d="M9.5 7.33333L12.8333 4"
    //           stroke="currentColor"
    //           strokeWidth="1.25"
    //           strokeLinecap="round"
    //           strokeLinejoin="round"
    //         />
    //         <path
    //           d="M9.5 0.666687L12.8333 4.00002"
    //           stroke="currentColor"
    //           strokeWidth="1.25"
    //           strokeLinecap="round"
    //           strokeLinejoin="round"
    //         />
    //       </svg>
    //     </div>
    //   </div>
    // </div>

    // ----------------------------------------- PAGINATION ---------------------------------------------

    <div className="flex justify-center items-center select-none lg:scale-[0.75] scale-[0.6]">

    

    <div className="flex jistify-between p-3.5 pg_box1 shadow-[0_-4px_8px_rgba(0,0,0,0.15),0_4px_8px_rgba(0,0,0,0.15)] rounded-full cursor-pointer mb-0">

      <div className="relative inline-block group me-3 max-[1300px]:mx-0">

          <button className="p-3 border m-0.5 bg-white hover:bg-blue-100 rounded-[50%] font-bold active:bg-blue-200 transition-all duration-100" onClick={()=>handleFirstLast("first")}>
            <svg xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="3"
                stroke="currentColor"
                class="w-5 h-5">
              <path stroke-linecap="round" stroke-linejoin="round"
                    d="M6 4v16M18 19l-7-7 7-7" />
            </svg>
          </button>

          <span className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 bg-gray-800 text-white whitespace-nowrap rounded px-2 py-1 text shadow-lg scale-0 group-hover:scale-100 transition">
            First
          </span>
      </div>

      <div className="relative inline-block group">
          <button className="p-3 px-2 m-1 max-[1300px]:mx-0 rounded rounded-[50%] hover:bg-blue-100 active:bg-blue-200 rounded-[50%] transition-all duration-100" onClick={()=>fun1("left")}>
            <svg
              className="w-6 h-4 text-gray-800 dark:text-black"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 14 14"
            >
              <path
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.5"
                d="M13 1 7.3 6.326a.91.91 0 0 0 0 1.348L13 13"
              />
              <path
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M7 1 1.3 6.326a.91.91 0 0 0 0 1.348L7 13"
              />
            </svg>
          </button>
           <span className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 bg-gray-800 text-white whitespace-nowrap rounded px-2 py-1 text shadow-lg scale-0 group-hover:scale-100 transition">
            Scroll <span className="border rounded-[50%] ps-1 pe-0.5">5-</span>
          </span>
      </div>

      <div className="relative inline-block group">
          <button className="p-3 px-2 m-1 max-[1300px]:mx-0 rounded rounded-[50%] hover:bg-blue-100 active:bg-blue-200 rounded-[50%] transition-all duration-100" onClick={()=>next_prev_page("previous")}>
            <svg
              className="w-6 h-4 text-gray-800 dark:text-black"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 8 14"
            >
              <path
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M7 1 1.3 6.326a.91.91 0 0 0 0 1.348L7 13"
              />
            </svg>
          </button>
           <span className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 bg-gray-800 text-white whitespace-nowrap rounded px-2 py-1 text shadow-lg scale-0 group-hover:scale-100 transition">
            Previous
          </span>
      </div>

      <ul ref={containRef} className="flex justify-between p-1 ">
        {items.map(num=>(
          <li onClick={(e)=>handleActive(e)} key={num} className={`${ num.toString().length ===1? "px-3.5" : num.toString().length ===2? "px-2.5" : "px-1"} py-1 mx-1 max-[1300px]:mx-0 rounded-[50%] font-semibold text-lg border transition ${active===num? "text-blue-600 bg-blue-100 border border-blue-500" : "text-black-500 border-gray-100"}`}>{num}</li>
        ))}
      </ul>

      <div className="relative inline-block group">
        <button className="p-3 px-2 m-1 max-[1300px]:mx-0 rounded rounded-[50%] hover:bg-blue-100 active:bg-blue-200 rounded-[50%] transition-all duration-100" onClick={()=>next_prev_page("next")}>
          <svg
            className="w-6 h-4 text-gray-800 dark:text-black"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 8 14"
          >
            <path
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="m1 13 5.7-5.326a.909.909 0 0 0 0-1.348L1 1"
            />
          </svg>
        </button>

        <span className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 bg-gray-800 text-white whitespace-nowrap rounded px-2 py-1 text shadow-lg scale-0 group-hover:scale-100 transition">
            Next
          </span>
      </div>

       <div className="relative inline-block group">
        <button className="p-3 px-2 m-1 max-[1300px]:mx-0 rounded rounded-[50%] hover:bg-blue-100 active:bg-blue-200 rounded-[50%] transition-all duration-100" onClick={()=>fun1("right")}>
         <svg
            className="w-6 h-4 text-gray-800 dark:text-black"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 14 14"
          >
            <path
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.5"
              d="m1 13 5.7-5.326a.909.909 0 0 0 0-1.348L1 1"
            />
            <path
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="m7 13 5.7-5.326a.909.909 0 0 0 0-1.348L7 1"
            />
          </svg>

        </button>
         <span className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 bg-gray-800 text-white whitespace-nowrap rounded px-2 py-1 text shadow-lg scale-0 group-hover:scale-100 transition">
            Scroll <span className="border rounded-[50%] ps-0.5 pe-0.5">5+</span>
          </span>
      </div>

      <div className="relative inline-block group flex rounded-full font-semibold border-blue-500 border p-1 py-1.5 px-3 m-0.5 ms-7 me-4 max-[1300px]:ms-0 max-[1300px]:ms-1 relative inline-block" onClick={()=>{setShowOverlay(!showOverlay)}}>
        <span className="px-2 py-0.5">{props.pagination_data.current_page_count}</span>
        <span className="py-0.5">/</span>
        <span className="px-2">page</span>
        <div>
          <button className="p-2 py-1 rounded ">
             <svg
                className="w-5 h-5 text-gray-800 "
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
              >
                <path
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="m19 9-7 7-7-7"
                />
              </svg>
          </button>
        </div>
        <span className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 bg-gray-800 text-white whitespace-nowrap rounded px-2 py-1 text shadow-lg scale-0 group-hover:scale-100 transition">
            Data in Current Page
          </span>
        {/* <Overlay show={showOverlay} totalPage={props.pagination_data.total_pages} position="top" /> */}
      </div>



      <div className="py-2.5 px-5 pr-2 max-[1300px]:px-0">
        <span className="font-semibold whitespace-nowrap">Go to</span>
      </div>

      <div className="p-0.5 relative inline-block group">
        <input ref={inputRef} onChange={handleType} className="border border-blue-500 focus:outline-none focus:ring-blue-200 rounded-full p-2 px-4 w-[4rem] text-center font-bold" type="text" name="page_number" placeholder="1"/>
         {/* <button className="px-2 py-2 ml-0 m-0.5 text-white bg-blue-500 hover:bg-blue-700 rounded-r-full font-bold active:bg-blue-800 transition-all duration-100" onClick={()=>goToPage()}>
            GO
          </button> */}
          <span className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 bg-gray-800 text-white whitespace-nowrap rounded px-2 py-1 text shadow-lg scale-0 group-hover:scale-100 transition">
            Type Page Number
          </span>
      </div>
     
      <div className="py-2.5 px-5 pl-2 max-[1300px]:ps-0 max-[1300px]:pe-1">
        <span className="font-semibold">Page</span>
      </div>

      <div className="me-0 relative inline-block group">
          <button className="px-6 py-2.5 m-0.5 text-white bg-blue-500 hover:bg-blue-700 rounded-full font-bold active:bg-blue-800 transition-all duration-100" onClick={()=>goToPage()}>
            GO
          </button>
          <span className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 bg-gray-800 text-white whitespace-nowrap rounded px-2 py-1 text shadow-lg scale-0 group-hover:scale-100 transition">
            Submit
          </span>
      </div>

      <div className="ms-3 relative inline-block group max-[1300px]:mx-0">
          <button className="border p-3 m-0.5 bg-white hover:bg-blue-100 rounded-[50%] font-bold active:bg-blue-200 transition-all duration-100" onClick={()=>handleFirstLast("last")}>
            <svg xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="3"
                stroke="currentColor"
                class="w-5 h-5">
              <path stroke-linecap="round" stroke-linejoin="round"
                   d="M18 4v16M6 5l7 7-7 7" />
            </svg>
          </button>

          <span className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 bg-gray-800 text-white whitespace-nowrap rounded px-2 py-1 text shadow-lg scale-0 group-hover:scale-100 transition">
            Last
          </span>

      </div>

    </div>

    </div>












    //  <div className="flex justify-between ">
    //   <div className="flex space-x-3">
    //     <a
    //       href="#"
    //       className="flex space-x-2 items-center justify-center px-3 h-8 me-3 text-sm font-medium text-gray-500 bg-white border border-gray-300 rounded-lg hover:bg-gray-100 hover:text-gray-700  "
    //       onClick={(e) => props.PaginationControl("prev", "")}
    //     >
    //       <svg
    //         className="w-3.5 h-3.5 me-2 rtl:rotate-180"
    //         aria-hidden="true"
    //         xmlns="http://www.w3.org/2000/svg"
    //         fill="none"
    //         viewBox="0 0 14 10"
    //       >
    //         <path
    //           stroke="currentColor"
    //           strokeLinecap="round"
    //           strokeLinejoin="round"
    //           strokwidth="2"
    //           d="M13 5H1m0 0 4 4M1 5l4-4"
    //         />
    //       </svg>
    //       <h1>Previous</h1>
    //     </a>
    //     <a
    //       href="#"
    //       className="flex space-x-2 items-center justify-center px-3 h-8 me-3 text-sm font-medium text-gray-500 bg-white border border-gray-300 rounded-lg hover:bg-gray-100 hover:text-gray-700  "
    //       onClick={(e) => props.PaginationControl("next", "")}
    //     >
    //       <h1>Next</h1>
    //       <svg
    //         className="w-3.5 h-3.5 ms-2 rtl:rotate-180"
    //         aria-hidden="true"
    //         xmlns="http://www.w3.org/2000/svg"
    //         fill="none"
    //         viewBox="0 0 14 10"
    //       >
    //         <path
    //           stroke="currentColor"
    //           strokeLinecap="round"
    //           strokeLinejoin="round"
    //           strokwidth="2"
    //           d="M1 5h12m0 0L9 1m4 4L9 9"
    //         />
    //       </svg>
    //     </a>
    //   </div>
    //   <div className="flex space-x-3">
    //     <button
    //       type="button"
    //       className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 "
    //     >
    //       {props.pagination_data.total_pages}
    //     </button>

    //     <input
    //       type="text"
    //       id="page_no"
    //       className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 "
    //       placeholder="Page Number"
    //       onChange={(e) => {
    //         setPage(e.target.value);
    //       }}
    //     />
    //     <button
    //       type="submit"
    //       className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm w-full sm:w-auto px-5 py-2.5 text-center"
    //       onClick={(e) => props.PaginationControl("page",page)}
    //     >
    //       Go
    //     </button>
    //   </div>
    //   <div className="flex space-x-3">
    //     <a
    //       href="#"
    //       className="flex space-x-2 items-center justify-center px-3 h-8 text-sm font-medium text-gray-500 bg-white border border-gray-300 rounded-lg hover:bg-gray-100 hover:text-gray-700  "
    //       onClick={(e) => props.PaginationControl("first", "")}
    //     >
    //       <svg
    //         className="w-3.5 h-3.5 me-2 rtl:rotate-180"
    //         aria-hidden="true"
    //         xmlns="http://www.w3.org/2000/svg"
    //         fill="none"
    //         viewBox="0 0 14 10"
    //       >
    //         <path
    //           stroke="currentColor"
    //           strokeLinecap="round"
    //           strokeLinejoin="round"
    //           strokwidth="2"
    //           d="M13 5H1m0 0 4 4M1 5l4-4"
    //         />
    //       </svg>
    //       <h1>First</h1>
    //     </a>

    //     <a
    //       href="#"
    //       className="flex space-x-2 items-center justify-center px-3 h-8 me-3 text-sm font-medium text-gray-500 bg-white border border-gray-300 rounded-lg hover:bg-gray-100 hover:text-gray-700  "
    //       onClick={(e) => props.PaginationControl("last", "")}
    //     >
    //       <h1>Last</h1>
    //       <svg
    //         className="w-3.5 h-3.5 ms-2 rtl:rotate-180"
    //         aria-hidden="true"
    //         xmlns="http://www.w3.org/2000/svg"
    //         fill="none"
    //         viewBox="0 0 14 10"
    //       >
    //         <path
    //           stroke="currentColor"
    //           strokeLinecap="round"
    //           strokeLinejoin="round"
    //           strokwidth="2"
    //           d="M1 5h12m0 0L9 1m4 4L9 9"
    //         />
    //       </svg>
    //     </a>
    //   </div>
    // </div>
    )}


      
    </>
  );
};

export default Pagination;




export const Overlay = ({ show, totalPage, position = "top" }) => {
  if (!show) return null;

  const positionClasses = {
    top: "bottom-full mb-2 left-1/2 -translate-x-1/2",
    bottom: "top-full mt-2 left-1/2 -translate-x-1/2",
  };

  // alert(typeof totalPage)

  return (
    <div
      className={`absolute z-[999] px-3 py-2 bg-white shadow-xl border border-blue-400 rounded-2xl w-[9.5rem] max-h-[15rem] min-h-[3rem] text-black-500 rounded shadow-lg ${positionClasses[position]}`}
    >
      <div className="overflow-y-auto max-h-[14rem] scrollbar-hide">
        {Array.from({ length: totalPage }, (_, i) => (
          <div key={i + 1} className="py-1 px-2 rounded mb-1 flex justify-between border-b border-gray-100">
            <h6>Page</h6>
            <h6> - </h6>
            <h6>{i+1}</h6>
          </div>
        ))}
      </div>
    </div>
  );
};
